export const formatLongName = (filename: string): string => {
	const MAX_CHARACTERS = 20
	if (filename.length > MAX_CHARACTERS) {
		return `${filename.substring(0, MAX_CHARACTERS)}...`
	}
	return filename
}
